import React from "react";

export default function User(props) {
  return (
    <>
      <button
        onClick={() => props._handleSelected(props.caseId)}
        className="flex flex-row gap-x-2 items-center hover:bg-gray-100 rounded p-1"
      >
        {props.profilePicture === "" ? (
          <div
            className={
              "flex w-10 h-10 bg-blue-200 rounded-full items-center justify-center text-black font-medium text-sm pointer-events-none"
            }
          >
            {props.name.firstName[0] + props.name.lastName[0]}
          </div>
        ) : (
          <img
            src={props.profilePicture}
            className={
              "flex w-10 h-10 bg-red-200 rounded-full pointer-events-none object-cover"
            }
          />
        )}
        {props.expanded ? (
          <label className="text-lg font-medium text-gray-700 pointer-events-none">
            {props.name.firstName + " " + props.name.lastName}
          </label>
        ) : null}
      </button>
    </>
  );
}
